// src/utils/authGuard.js
import store from '../redux/store';
import { restoreAuthState } from '../redux';
import { LOGIN_PATH } from '../constants/uploadConfig';
import { PUBLIC_PATHS } from '../constants/authConfig';
import { replaceLocation } from './navigation';

/**
 * Restores auth state from sessionStorage and redirects to login
 * if user is unauthenticated and accessing a private route.
 * Should be called once at app startup.
 *
 * @returns {Promise<boolean>} true if auth was restored, false otherwise
 */
export const initializeAuthGuard = async () => {
    // Skip auth check during OAuth callback (code exchange in progress)
    const href = window.location.href || '';
    if (href && href.includes('code=')) {
        return true;
    }

    const authRestored = await store.dispatch(restoreAuthState());
    if (!authRestored && !PUBLIC_PATHS.includes(window.location.pathname)) {
        replaceLocation(LOGIN_PATH);
    }
    return authRestored;
};